var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dateTime } from "@gravity-ui/date-utils";
import { timeConvertToDateTime } from "@/tools/dateTools";
export var convertToScheduleViewModel = function (data) {
    var viewData = __assign(__assign({}, data), { repeatMode: [data.repeatMode], startDate: data.startDate ? dateTime({ input: data.startDate }) : null, stopDate: data.stopDate ? dateTime({ input: data.stopDate }) : null, workTimeMode: [data.workTimeMode], maxDurationHours: [String(data.maxDurationHours)], maxDurationMinutes: [String(data.maxDurationMinutes)], minDurationHours: [String(data.minDurationHours)], minDurationMinutes: [String(data.minDurationMinutes)], timeSlots: data.timeSlots.map(function (slot) { return ({
            timeStart: timeConvertToDateTime(slot.timeStart),
            timeEnd: timeConvertToDateTime(slot.timeEnd),
            id: slot.id,
        }); }), status: [data.status] });
    return viewData;
};
